<div class="col-md-12 p-3">
  <app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
  <div class="row">
    <div class="col-md-3 text-left p-0">
      <div class="text-blue" *ngIf="(selfAssessmentSummary && (selfAssessmentSummary.length>0)) || (selfAssessmentT2Summary && (selfAssessmentT2Summary.length>0))||(showT3Summary && totalCount>0)">
        <div>{{endIndex}} out of {{totalCount}}
          <span *ngIf="selectedItems.length > 0"> ({{selectedItems.length}} selected)</span>
        </div>
      </div>
    </div>
    <div class="col-md-9 mb-2" >
      <div class="pull-right" style="right: 20px;">
        <span class="cursor-pointer text-blue" *ngIf="commonService.checkPlanTypeAction('SAER')"
          (click)="downloadReport()"><span class="fa fa-download"></span>
          Export Report 
        </span>
        <span class="cursor-pointer text-blue pl-3" (click)="bulkUpdate()"  *ngIf="commonService.checkPlanTypeAction('SABU')">
          Bulk Update
        </span>
        <!-- <span class="cursor-pointer fg-red pl-3" *ngIf="commonService.checkPlanTypeAction('SAD')"
          (click)="deleteItem()"><span class="fa fa-trash"></span>
          Delete
        </span> -->
        <span class="cursor-pointer fg-red pl-3"
          (click)="deleteItem()" *ngIf="commonService.checkPlanTypeAction('SAD')"><span class="fa fa-trash"></span>
          Delete
        </span>

        <span class="text-capitalize pl-3 position-relative" dropdown #dropdown="bs-dropdown" [insideClick]="true"
          [autoClose]="false">
          <span dropdownToggle class="dropdown-toggle cursor-pointer text-blue">
            Filters <span class="caret" #dropInput></span>
          </span>
          <div id="dropdown-triggers-manual" *dropdownMenu class="dropdown-menu self-assesment-filter-dropdown px-0 py-3"
            role="menu" aria-labelledby="button-triggers-manual" style="width: 100%;">
            <div class="dropdown-filter-part">
                <app-self-assessment-filter *ngIf="templateNo != 2 && templateNo !=3 " (OnFilter)="OnFilter($event)"></app-self-assessment-filter>
                <app-self-assessment-t2-filter *ngIf="templateNo == 2" (OnFilterT2)="OnFilterT2($event)"></app-self-assessment-t2-filter>
                <app-self-assessment-t3-filter *ngIf="templateNo == 3" (OnFilterT3)="onFilterT3($event)" ></app-self-assessment-t3-filter>
              <button class="fa fa-times cross-button filter-close-button" (click)="dropInput.click()"></button>
            </div>
          </div>
        </span>
        <span class="pl-3" dropdown #dropdown="bs-dropdown" [insideClick]="true" [autoClose]="false">
          <span dropdownToggle class="cursor-pointer text-blue">
            <span class="fa fa-cog setting-icon" #dropInputsettings></span>
          </span>
          <div class="row">
            <div class="col-lg-5"></div>
            <div class="col-lg-3">
              <div id="dropdown-triggers-manual" *dropdownMenu
                class="dropdown-menu settings-dropdown-menu p-3 height-400 overflow-auto" role="menu"
                aria-labelledby="button-triggers-manual" style="width: 250px;">
                <div class="dropdown-filter-part pt-2">
                  <div class="dropdown_flex" *ngIf="templateNo == 1">
                    <div class="dropdown_item" *ngFor="let item of itemActiveModel">
                      <input type="checkbox"
                        (change)="showHideColumn(item.itemTitle, item.itemWidth, item.isActive, 'Change')"
                        [(ngModel)]="item.isActive" [attr.checked]="item.isActive ? 'checked' : null" />
                      <span class="ml-2">{{ item.itemTitle }} </span>
                    </div>
                  </div>
                  <div class="dropdown_flex" *ngIf="templateNo == 2">
                    <div class="dropdown_item" *ngFor="let item of itemActiveModelT2">
                      <input type="checkbox"
                        (change)="showHideColumnT2(item.itemTitle, item.itemWidth, item.isActive, 'Change')"
                        [(ngModel)]="item.isActive" [attr.checked]="item.isActive ? 'checked' : null" />
                      <span class="ml-2">{{ item.itemTitle }}</span>
                    </div>
                  </div>
                  <div class="dropdown_flex" *ngIf="templateNo == 3">
                    <div class="dropdown_item" *ngFor="let item of itemActiveModelT3">
                      <input type="checkbox"
                        (change)="showHideColumnT3(item.itemTitle, item.itemWidth, item.isActive, 'Change')"
                        [(ngModel)]="item.isActive" [attr.checked]="item.isActive ? 'checked' : null" />
                      <span class="ml-2">{{ item.itemTitle }}</span>
                    </div>
                  </div>
                  <button class="fa fa-times cross-button filter-close-button" type="button"
                    (click)="dropInputsettings.click()"></button>
                </div>
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>
    <div *ngIf="templateNo == 1" class="table-responsive box-shadow table-cont body-style" #tableContent>
      <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
      <span class="fa fa-arrow-left text-muted arrows arrow-left" (click)="scrollLeft()"></span>
      <span class="fa fa-arrow-right text-muted arrows arrow-right" (click)="scrollRight()"></span>
      <table class="table table-fixed table-hover mb-0 table_hoizental">
        <thead>
          <tr>
            <th class="text-center width-1pr">
              <input type="checkbox" [checked]="selectedItems.length > 0 ? 'checked' : ''" (change)="allSelectedItems($event, this.selfAssessmentSummary)" />
            </th>
            <th class="width-3pr text-center " (click)="sortSelfAssessment('RulebookRuleID')">Id
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentFilter.SortKey === 'RulebookRuleID' && !selfAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentFilter.SortKey === 'RulebookRuleID' && selfAssessmentFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center " (click)="sortSelfAssessment('Type')">Type
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentFilter.SortKey === 'Type' && !selfAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentFilter.SortKey === 'Type' && selfAssessmentFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center " (click)="sortSelfAssessment('RuleID')">RuleID
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentFilter.SortKey === 'RuleID' && !selfAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentFilter.SortKey === 'RuleID' && selfAssessmentFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentColumns.owner" (click)="sortSelfAssessment('Owner')">Owner
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentFilter.SortKey === 'Owner' && !selfAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentFilter.SortKey === 'Owner' && selfAssessmentFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentColumns.assessmentCreationDate" (click)="sortSelfAssessment('CreatedDateTime')">Assessment Creation Date
              <i class="fa"
                [ngClass]="{'fa-sort-amount-asc': (selfAssessmentFilter.SortKey === 'CreatedDateTime' && !selfAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentFilter.SortKey === 'CreatedDateTime' && selfAssessmentFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentColumns.assessmentLastEdited" (click)="sortSelfAssessment('AssessmentLastEdited')">Assessment Last Edited
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentFilter.SortKey === 'AssessmentLastEdited' && !selfAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentFilter.SortKey === 'AssessmentLastEdited' && selfAssessmentFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentColumns.assessmentTeam" (click)="sortSelfAssessment('AssessmentTeam')">Assessment Team
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentFilter.SortKey === 'AssessmentTeam' && !selfAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentFilter.SortKey === 'AssessmentTeam' && selfAssessmentFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentColumns.assessor" (click)="sortSelfAssessment('Assessor')">Assessor
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentFilter.SortKey === 'Assessor' && !selfAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentFilter.SortKey === 'Assessor' && selfAssessmentFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentColumns.assessorDelegate" (click)="sortSelfAssessment('AssessorDelegate')">Assessor Delegate
              <i class="fa"
                [ngClass]="{'fa-sort-amount-asc': (selfAssessmentFilter.SortKey === 'AssessorDelegate' && !selfAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentFilter.SortKey === 'AssessorDelegate' && selfAssessmentFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentColumns.reviewTeam" (click)="sortSelfAssessment('ReviewTeam')">Review Team
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentFilter.SortKey === 'ReviewTeam' && !selfAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentFilter.SortKey === 'ReviewTeam' && selfAssessmentFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentColumns.reviewer" (click)="sortSelfAssessment('Reviewer')">Reviewer
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentFilter.SortKey === 'Reviewer' && !selfAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentFilter.SortKey === 'Reviewer' && selfAssessmentFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentColumns.reviewerDelegate" (click)="sortSelfAssessment('ReviewerDelegate')">Reviewer Delegate
              <i class="fa"
                [ngClass]="{'fa-sort-amount-asc': (selfAssessmentFilter.SortKey === 'ReviewerDelegate' && !selfAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentFilter.SortKey === 'ReviewerDelegate' && selfAssessmentFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentColumns.assessmentStatus" (click)="sortSelfAssessment('AssessmentStatus')">Assessment Status
              <i class="fa"
                [ngClass]="{'fa-sort-amount-asc': (selfAssessmentFilter.SortKey === 'AssessmentStatus' && !selfAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentFilter.SortKey === 'AssessmentStatus' && selfAssessmentFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-5pr text-center" *ngIf="selfAssessmentColumns.assessmentDueDate" (click)="sortSelfAssessment('AssessmentDueDate')">Assessment Due Date
              <i class="fa"
                [ngClass]="{'fa-sort-amount-asc': (selfAssessmentFilter.SortKey === 'AssessmentDueDate' && !selfAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentFilter.SortKey === 'AssessmentDueDate' && selfAssessmentFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentColumns.reviewStatus" (click)="sortSelfAssessment('ReviewStatus')">Review Status
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentFilter.SortKey === 'ReviewStatus' && !selfAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentFilter.SortKey === 'ReviewStatus' && selfAssessmentFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentColumns.reviewDueDate" (click)="sortSelfAssessment('ReviewDueDate')">Review Due Date
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentFilter.SortKey === 'ReviewDueDate' && !selfAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentFilter.SortKey === 'ReviewDueDate' && selfAssessmentFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentColumns.overallStatus" (click)="sortSelfAssessment('OverallRuleStatus')">Overall Rule Status
              <i class="fa"
                [ngClass]="{'fa-sort-amount-asc': (selfAssessmentFilter.SortKey === 'OverallRuleStatus' && !selfAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentFilter.SortKey === 'OverallRuleStatus' && selfAssessmentFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-8pr text-center" *ngIf="selfAssessmentColumns.conclusion" (click)="sortSelfAssessment('Conclusion')">Conclusion
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentFilter.SortKey === 'Conclusion' && !selfAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentFilter.SortKey === 'Conclusion' && selfAssessmentFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center">Action</th>
          </tr>
        </thead>
        <tbody *ngIf="selfAssessmentSummary.length === 0">
          <tr>
            <td>No Data</td>
          </tr>
        </tbody>
        <tbody *ngIf="(selfAssessmentSummary && (selfAssessmentSummary.length > 0))"
          [style.max-height.px]="myInnerHeight">
          <cdk-virtual-scroll-viewport class="list-container list-group" itemSize="35"
            (scrolledIndexChange)="handler($event)" [style.height.px]="myInnerHeight"
            *ngIf="selfAssessmentSummary.length > 0">
            <div *cdkVirtualFor="let item of selfAssessmentSummary; let i = index">
              <tr [ngClass]="{
                'd-highlight': item.id === newSAItemId,
                'highlighted-row': shouldHighlightRow(i),
                'selected-row': selectedItemId > 0 && selectedItemId === item.id
              }" (click)="selectedItemId = item.id" (dblclick)="redirectLink(item.id)">
              <!-- <tr [ngClass]="item.id === newSAItemId ? 'd-highlight' : ''"   [ngClass]="{'highlighted-row': shouldHighlightRow(row)}" *cdkVirtualFor="let row of rows"> -->
                <td class="width-1pr text-center " scope="row">
                  <i class="fa fa-square-o icon-font"
                  (click)="selectItem('Checked',item.id)"
                  *ngIf="!_globalService.getSelectedItems(item.id, selectedItems)" aria-hidden="true">
                  </i>
                  <i class="fa fa-check-square icon-font"
                  (click)="selectItem('UnChecked',item.id)"
                  *ngIf="_globalService.getSelectedItems(item.id, selectedItems)" aria-hidden="true">
                  </i>
                </td>
                <td class="width-3pr text-center tabel-td-scroll " scope="row">
                  <a (click)="redirectLink(item.id)">
                    <p class="mb-0" *ngFor="let rId of item.rulebookRuleId.split('|')">{{rId}}</p>
                  </a>
                </td>
                <td class="width-6pr text-center tabel-td-scroll " scope="row">{{item.type}}</td>
                <td class="width-6pr text-center tabel-td-scroll " scope="row">
                  <div *ngIf="item.ruleID != null">
                    <p class="mb-0" *ngFor="let rRuleId of item.ruleID.split('|')">{{rRuleId}} </p>
                  </div>
                </td>
                <td class="width-6pr text-center tabel-td-scroll" *ngIf="selfAssessmentColumns.owner" scope="row">
                  <div *ngIf="item.owner != null">
                    <p class="mb-0" *ngFor="let rOwner of item.owner.split('|')">{{rOwner}}</p>
                  </div>
                </td>
                <td class="width-6pr text-center tabel-td-scroll" *ngIf="selfAssessmentColumns.assessmentCreationDate" scope="row">
                  {{item.createdDateTime | date:'dd-MMM-yyyy'}}
                </td>
                <td class="width-6pr text-center tabel-td-scroll" *ngIf="selfAssessmentColumns.assessmentLastEdited" scope="row">
                  {{item.assessmentLastEdited | date:'dd-MMM-yyyy'}}
                </td>
                <td class="width-6pr text-center tabel-td-scroll" *ngIf="selfAssessmentColumns.assessmentTeam" scope="row">{{item.assessmentTeam}}</td>
                <td class="width-6pr text-center tabel-td-scroll" *ngIf="selfAssessmentColumns.assessor" scope="row">{{item.assessor}}</td>
                <td class="width-6pr text-center tabel-td-scroll" *ngIf="selfAssessmentColumns.assessorDelegate" scope="row">{{item.assessorDelegate}}</td>
                <td class="width-6pr text-center tabel-td-scroll" *ngIf="selfAssessmentColumns.reviewTeam" scope="row">{{item.reviewTeam}}</td>
                <td class="width-6pr text-center tabel-td-scroll" *ngIf="selfAssessmentColumns.reviewer" scope="row">{{item.reviewer}}</td>
                <td class="width-6pr text-center tabel-td-scroll" *ngIf="selfAssessmentColumns.reviewerDelegate" scope="row">{{item.reviewerDelegate}}</td>
                <td class="width-6pr text-center tabel-td-scroll" *ngIf="selfAssessmentColumns.assessmentStatus" scope="row">{{item.assessmentStatus}}</td>
                <td class="width-5pr text-center tabel-td-scroll" *ngIf="selfAssessmentColumns.assessmentDueDate" scope="row">{{item.assessmentDueDate |
                  date:'dd-MMM-yyyy'}}</td>
                <td class="width-6pr text-center tabel-td-scroll" *ngIf="selfAssessmentColumns.reviewStatus" scope="row">{{item.reviewStatus}}</td>
                <td class="width-6pr text-center tabel-td-scroll" *ngIf="selfAssessmentColumns.reviewDueDate" scope="row">{{item.reviewDueDate |
                  date:'dd-MMM-yyyy'}}</td>
                <td class="width-6pr text-center tabel-td-scroll" *ngIf="selfAssessmentColumns.overallStatus" scope="row">{{item.overallRuleStatus}}</td>
                <td class="width-8pr tabel-td-scroll text-center" *ngIf="selfAssessmentColumns.conclusion" scope="row">{{item.conclusion}}</td>
                <td class="width-6pr text-center tabel-td-scroll"><a
                    href="/self-assessment/details/self/{{item.id}}">View</a> |
                  <span *ngIf="currentUserRole === 'Compliance Enterprise'">
                    <a (click)="openCopyDialog(item.id)">Copy</a>
                  </span>
                  <span *ngIf="currentUserRole !== 'Compliance Enterprise'">
                    <span *ngIf="checkSAUserAuth(item)">
                      <a (click)="openCopyDialog(item.id)">Copy</a>
                    </span>
                    <span class="disabled" *ngIf="!checkSAUserAuth(item)">Copy</span>
                  </span>
                </td>
              </tr>
            </div>
          </cdk-virtual-scroll-viewport>
        </tbody>
      </table>
    </div>
    <!--For New Template-->
    <div *ngIf="templateNo == 2" class="table-responsive box-shadow table-cont body-style2" #tableContentT2>
      <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
      <span class="fa fa-arrow-left text-muted arrows arrow-left" (click)="scrollLeft()"></span>
      <span class="fa fa-arrow-right text-muted arrows arrow-right" (click)="scrollRight()"></span>
      <table class="table table-fixed table-hover mb-0 table_hoizental">
        <thead>
          <tr>
            <th class="text-center width-1pr">
              <input type="checkbox" [checked]="selectedItems.length > 0 ? 'checked' : ''" (change)="allSelectedItems($event,this.selfAssessmentT2Summary)" />
            </th>
            <th class="width-3pr text-center" (click)="sortSelfAssessment('RulebookRuleID')">Id
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'RulebookRuleID' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'RulebookRuleID' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" (click)="sortSelfAssessment('Part')">Part
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'Part' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'Part' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" (click)="sortSelfAssessment('RuleID')">Rule Id
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'RuleID' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'RuleID' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" (click)="sortSelfAssessment('Owner')">Owner
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'Owner' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'Owner' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.assessmentCategory" (click)="sortSelfAssessment('AssessmentCategory')">Assessment Category
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'AssessmentCategory' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'AssessmentCategory' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.assessmentDueDate" (click)="sortSelfAssessment('AssessmentDueDate')">Assessment Due Date
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'AssessmentDueDate' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'AssessmentDueDate' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.assessmentTeam" (click)="sortSelfAssessment('AssessmentTeam')">Assessment Team
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'AssessmentTeam' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'AssessmentTeam' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.assessor" (click)="sortSelfAssessment('Assessor')">Assessor
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'Assessor' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'Assessor' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.assessmentStatus" (click)="sortSelfAssessment('AssessmentStatus')">Assessment Status
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'AssessmentStatus' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'AssessmentStatus' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.assessmentCreationDate" (click)="sortSelfAssessment('AssessmentCreationDate')">Assessment Creation Date
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'AssessmentCreationDate' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'AssessmentCreationDate' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.complianceStatus" (click)="sortSelfAssessment('ComplianceStatus')">Compliance Status
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'ComplianceStatus' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'ComplianceStatus' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.interpretation" (click)="sortSelfAssessment('Interpretation')">Interpretation
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'Interpretation' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'Interpretation' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-8pr text-center" *ngIf="selfAssessmentT2Columns.judgement" (click)="sortSelfAssessment('Judgement')">Judgements
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'Judgement' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'Judgement' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.noOfJudgements">No. of Judgements</th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.gaps" (click)="sortSelfAssessment('Gaps')">Limitations
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'Gaps' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'Gaps' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.noOfGaps">No. of Limitations</th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.noOfGapsRiskAccepted">No. of Limitations Requiring Action</th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.enhancement" (click)="sortSelfAssessment('Enhancement')">Actions
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'Enhancement' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'Enhancement' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.noOfEnhancement">No. of Actions</th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.riskRecommendation" (click)="sortSelfAssessment('RiskRecommendation')">No. of Risk Recommendations
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'RiskRecommendation' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'RiskRecommendation' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <!-- <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.riskRecommendationStatus" (click)="sortSelfAssessment('RiskRecommendationStatus')">Risk Recommendation Status
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'RiskRecommendationStatus' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'RiskRecommendationStatus' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th> Removed on request of LBG-->
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.reviewerTeam" (click)="sortSelfAssessment('ReviewerTeam')">Reviewer Team
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'ReviewerTeam' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'ReviewerTeam' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.reviewer" (click)="sortSelfAssessment('Reviewer')">Reviewer
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'Reviewer' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'Reviewer' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.reviewStatus" (click)="sortSelfAssessment('ReviewStatus')">Review Status
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'ReviewStatus' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'ReviewStatus' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.approvalTeam" (click)="sortSelfAssessment('ApprovalTeam')">Approval Team
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'ApprovalTeam' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'ApprovalTeam' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.approvers" (click)="sortSelfAssessment('Approvers')">Approvers
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'Approvers' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'Approvers' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.approvalStatus" (click)="sortSelfAssessment('ApprovalStatus')">Approval Status
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'ApprovalStatus' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'ApprovalStatus' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" *ngIf="selfAssessmentT2Columns.lastApproved" (click)="sortSelfAssessment('LastApproved')">Last Approved
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2Filter.SortKey === 'LastApproved' && !selfAssessmentT2Filter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2Filter.SortKey === 'LastApproved' && selfAssessmentT2Filter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center">Action</th>
          </tr>
        </thead>
        <tbody *ngIf="selfAssessmentT2Summary.length === 0">
          <tr>
            <td>No Data</td>
          </tr>
        </tbody>
        <tbody *ngIf="(selfAssessmentT2Summary && (selfAssessmentT2Summary.length > 0))"
          [style.max-height.px]="myInnerHeight"><!--Have to change here-->
          <cdk-virtual-scroll-viewport class="list-container list-group" itemSize="35"
            (scrolledIndexChange)="handler($event)" [style.height.px]="myInnerHeight"
            *ngIf="selfAssessmentT2Summary.length > 0"><!--Have to change here-->
            <div *cdkVirtualFor="let item of selfAssessmentT2Summary; let i = index">
              <tr [ngClass]="{
                'd-highlight': item.id === newSAItemId,
                'highlighted-row': shouldHighlightRow(i),
                'selected-row': selectedItemId > 0 && selectedItemId === item.id
              }" (click)="selectedItemId = item.id" (dblclick)="redirectLinkT2(item.id)">
              <!-- <tr [ngClass]="item.id === newSAItemId ? 'd-highlight' : ''"   [ngClass]="{'highlighted-row': shouldHighlightRow(row)}" *cdkVirtualFor="let row of rows"> -->
                <td class="width-1pr text-center " scope="row">
                  <!-- <input type="checkbox"
                    [checked]="item.id === newSAItemId ? 'checked' : ''" (change)="selectItem($event, item.id)" /> -->

                  <i class="fa fa-square-o icon-font"
                    (click)="selectItem('Checked',item.id)"
                    *ngIf="!_globalService.getSelectedItems(item.id, selectedItems)" aria-hidden="true"></i>
                  <i class="fa fa-check-square icon-font"
                    (click)="selectItem('UnChecked',item.id)"
                    *ngIf="_globalService.getSelectedItems(item.id, selectedItems)" aria-hidden="true"></i>
                  </td>
                <td class="width-3pr text-center tabel-td-scroll " scope="row">
                  <a  (click)="redirectLinkT2(item.id)">
                    <p class="mb-0" *ngFor="let rId of item.rulebookRuleId.split('|')">{{rId}}</p>
                  </a>
                </td>
                <td class="width-6pr text-center tabel-td-scroll " scope="row">{{item.part}}</td>
                <td class="width-6pr text-center tabel-td-scroll " scope="row">{{item.ruleID}}</td>
                <td class="width-6pr text-center tabel-td-scroll" scope="row">
                  <div *ngIf="item.owner != null">
                    <p class="mb-0" *ngFor="let rOwner of item.owner.split('|')">{{rOwner}}</p>
                  </div>
                </td>
                <td *ngIf="selfAssessmentT2Columns.assessmentCategory" class="width-6pr text-center tabel-td-scroll " scope="row">{{item.assessmentCategory}}</td>
                <td *ngIf="selfAssessmentT2Columns.assessmentDueDate" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.assessmentDueDate | date:'dd-MMM-yyyy'}}</td>
                <td *ngIf="selfAssessmentT2Columns.assessmentTeam" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.assessmentTeam}}</td>
                <td *ngIf="selfAssessmentT2Columns.assessor" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.assessor}}</td>
                <td *ngIf="selfAssessmentT2Columns.assessmentStatus" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.assessmentStatus}}</td>
                <td *ngIf="selfAssessmentT2Columns.assessmentCreationDate" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.assessmentCreationDate | date:'dd-MMM-yyyy'}}</td>
                <td *ngIf="selfAssessmentT2Columns.complianceStatus" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.complianceStatus}}</td>
                <td *ngIf="selfAssessmentT2Columns.interpretation" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.interpretation}}</td>
                <td *ngIf="selfAssessmentT2Columns.judgement" class="width-8pr text-center tabel-td-scroll" scope="row">{{item.judgement}}</td>
                <td *ngIf="selfAssessmentT2Columns.noOfJudgements" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.noOfJudgements}}</td>
                <td *ngIf="selfAssessmentT2Columns.gaps" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.gaps}}</td>
                <td *ngIf="selfAssessmentT2Columns.noOfGaps" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.noOfGaps}}</td>
                <td *ngIf="selfAssessmentT2Columns.noOfGapsRiskAccepted" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.noOfGapsRiskAccepted}}</td>
                <td *ngIf="selfAssessmentT2Columns.enhancement" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.enhancement}}</td>
                <td *ngIf="selfAssessmentT2Columns.noOfEnhancement" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.noOfEnhancement}}</td>
                <td *ngIf="selfAssessmentT2Columns.riskRecommendation" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.riskRecommendation}}</td>
                <!-- <td *ngIf="selfAssessmentT2Columns.riskRecommendationStatus" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.riskRecommendationStatus}}</td> Removed on request of LBG-->
                <td *ngIf="selfAssessmentT2Columns.reviewerTeam" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.reviewerTeam}}</td>
                <td *ngIf="selfAssessmentT2Columns.reviewer" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.reviewer}}</td>
                <td *ngIf="selfAssessmentT2Columns.reviewStatus" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.reviewStatus}}</td>
                <td *ngIf="selfAssessmentT2Columns.approvalTeam" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.approvalTeam}}</td>
                <td *ngIf="selfAssessmentT2Columns.approvers" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.approvers}}</td>
                <td *ngIf="selfAssessmentT2Columns.approvalStatus" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.approvalStatus}}</td>
                <td *ngIf="selfAssessmentT2Columns.lastApproved" class="width-6pr text-center tabel-td-scroll" scope="row">{{item.lastApproved | date:'dd-MMM-yyyy'}}</td>
                <td class="width-6pr text-center tabel-td-scroll"><a
                    href="/self-assessment/details/self/2/{{item.id}}">View</a> |
                  <span *ngIf="currentUserRole === 'Compliance Enterprise'">
                    <a (click)="openCopyDialog(item.id)">Copy</a>
                  </span>
                  <span *ngIf="currentUserRole !== 'Compliance Enterprise'">
                    <span *ngIf="checkSAT2UserAuth(item)">
                      <a (click)="openCopyDialog(item.id)">Copy</a>
                    </span>
                    <span class="disabled" *ngIf="!checkSAT2UserAuth(item)">Copy</span>
                  </span>
                </td>
              </tr>
            </div>
          </cdk-virtual-scroll-viewport>
        </tbody>
      </table>
    </div>
    <!--for template3 -->
    <div class="table-responsive box-shadow table-cont body-style3" *ngIf="templateNo == 3">
      <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
      <app-self-assessment-t3-summary
      *ngIf="showT3Summary"
      (selectData)="receiveData($event)"
      [selfAssessmentT3FilterData] = "selfAssessmentT3FilterData"
      [selfAssessmentT3ColumnModel]="selfAssessmentT3ColumnModel"
      [(totalCount)]="totalCount"
      (totalData)="summaryTotalDataChange($event)"
      (endIndexUpdate)="endIndexUpdate($event)"
      >
      </app-self-assessment-t3-summary>
    </div>
  </div>
</div>
